import axios from 'axios';

class GithubServiceInfo {
  constructor(host, token) {
    this.host = host;
    this.token = token;
  }
  async getOrgsGithub() {
    const GITHUB_ORGS_URL = `https://api.${this.host}/user/orgs`;
    const headers = {
      Authorization: `Bearer ${this.token}`
    };
    const orgsList = [];
    try {
      const response = await axios.get(GITHUB_ORGS_URL, { headers });
      if (response.status === 200) {
        const orgs = response.data;
        for (const org of orgs) {
          orgsList.push(org.login);
        }
        return orgsList;
      }
      orgsList.push("Not orgs");
      return orgsList;
    } catch (error) {
      orgsList.push("Not orgs");
      return orgsList;
    }
  }
  async getUserGithub() {
    const GITHUB_USER_URL = `https://api.${this.host}/user`;
    const headers = {
      Authorization: `token ${this.token}`
    };
    try {
      const response = await axios.get(GITHUB_USER_URL, { headers });
      if (response.status === 200) {
        const owner = response.data.login;
        return owner;
      }
      return "Not found";
    } catch (error) {
      return "Not Found";
    }
  }
}

export { GithubServiceInfo };
//# sourceMappingURL=index.esm.js.map
